import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  useTable,
  useFlexLayout
} from 'react-table';
import './Table.css'

function SubTable(props) {
  const {
    columns = null,
    row = null
  } = props;

  const tableInstance = useTable({ columns, data: row.original.cmses }, useFlexLayout);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow
  } = tableInstance;

  return (
    <table className="table table-bordered" id="subTable" {...getTableProps()}>
      <thead>
        <tr>
          {headerGroups.map(headerGroup => (
            headerGroup.headers.map(column => {
              return (
                <th {...column.getHeaderProps()}>
                  <FormattedMessage id={column.render('Header')} />
                </th>
              );
            })
          ))}
        </tr>
      </thead>
      <tbody {...getTableBodyProps()}>
        {rows.map(row => {
          prepareRow(row);
          return (
            <tr {...row.getRowProps()}>
              {row.cells.map(cell => {
                return (
                  <td {...cell.getCellProps()}>
                    {cell.render('Cell')}
                  </td>
                );
              })}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}

export default SubTable;
